import React, { useEffect } from 'react';
import { useStateMachine } from 'little-state-machine';
/* import { useMsal } from '@azure/msal-react';
 */ import { PageContentContainer } from '../layout/PageContentContainer';
import { PageTitle } from '../layout/components/page/PageTitle';
import { Breadcrumbs } from '../layout/components/page/Breadcrumbs';
import { InvoiceDetailModal } from '../components/dialog/InvoiceDetailModal/InvoiceDetailModal';
import { InvoiceTable } from '../tables/InvoiceTable';
import { useWorkInProgressQuery } from '../../../query/WorkInProgressQuery';
import { Invoice } from '../../../dto/Invoice';
import { useMsal } from '@azure/msal-react';
import { checkAuthorisation } from '../checkAuthorisation';
import { LinearProgress } from '@material-ui/core';

const filterData = (
  account: string,
  invoices?: Invoice[] | undefined
): Invoice[] | undefined => {
  if (!invoices) return undefined;
  const accountIntern = account.replace('@intern.', '@');
  return invoices.filter((invoice) => {
    return (
      invoice.acceptors.includes(account.toLowerCase()) ||
      invoice.mailObserver.includes(account.toLowerCase()) ||
      invoice.acceptors.includes(accountIntern.toLowerCase()) ||
      invoice.mailObserver.includes(accountIntern.toLowerCase()) ||
      checkAuthorisation(account.toLowerCase()) ||
      checkAuthorisation(accountIntern.toLowerCase())
    );
  });
};

export const WorkInProgressPage = (): JSX.Element => {
  const filterStatus = ['1', '6', '7', '5', '11', '12'];
  const {
    data,
    error,
    refetch,
    isLoading,
    isFetching,
  } = useWorkInProgressQuery({
    invoiceStatus: filterStatus,
  });
  const { state } = useStateMachine();
  const { accounts } = useMsal();

  useEffect(() => {
    if (state.selectedInvoice === undefined) {
      refetch();
    }
  }, [state.selectedInvoice]);

  const filteredData = filterData(accounts[0].username!, data?.invoices);

  return (
    <PageContentContainer>
      <PageTitle>Rechnungen in Bearbeitung</PageTitle>
      <Breadcrumbs
        pageTitle="In Bearbeitung"
        entries={[{ name: 'Dashboard', to: '/' }]}
      />
      <div>
        {error && (
          <>
            <p style={{ color: 'red' }}>
              Derzeit besteht keine Verbindung zum Server
            </p>
          </>
        )}
        {(isLoading || isFetching) && <LinearProgress color="secondary" />}
        {data && <InvoiceTable invoiceData={filteredData!} />}
      </div>
      {state.selectedInvoice !== undefined && (
        <InvoiceDetailModal
          config="workInProgress"
          queryString="workInProgress"
        />
      )}
    </PageContentContainer>
  );
};
